import React, { useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Box,
  Chip,
  Divider
} from '@material-ui/core';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import PersonPinCircleOutlinedIcon from '@material-ui/icons/PersonPinCircleOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import { I18nContext } from 'translations';

const EMPTY = '-';
const COMPANY_PROFILE_SOURCE = 'company_profile';

const formatPhone = ({ country_code, phone } = {}) =>
  phone ? `${country_code ? `+${country_code} ` : ''}${phone}` : null;

const ContactRow = ({ icon, value }) => (
  <Box display="flex" alignItems="center" mt={0.5} style={{ gap: 8 }}>
    {React.cloneElement(icon, { fontSize: 'small', color: 'action' })}
    <Typography variant="body2" color={value ? 'textPrimary' : 'textSecondary'}>
      {value || EMPTY}
    </Typography>
  </Box>
);

const ContactSection = ({ icon, title, tag, name, phone, email, showEmail }) => (
  <Box p={2} style={{ border: '1px solid #E9E6FF', borderRadius: 8, background: '#FAF8FF' }}>
    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
      <Box display="flex" alignItems="center" style={{ gap: 8, color: '#7825BD' }}>
        {icon}
        <Typography variant="subtitle2" color="primary">{title}</Typography>
      </Box>
      {tag && <Chip size="small" label={tag} variant="outlined" />}
    </Box>
    <Divider />
    <Box mt={1}>
      <ContactRow icon={<PersonOutlineIcon />} value={name} />
      <ContactRow icon={<PhoneOutlinedIcon />} value={phone} />
      {showEmail && <ContactRow icon={<EmailOutlinedIcon />} value={email} />}
    </Box>
  </Box>
);

const ModalPrepackageCustomer = ({ open, handleClose, customer, originContact }) => {
  const { translate } = useContext(I18nContext);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{translate('prepackages.customer.title')}</DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
          <ContactSection
            icon={<StorefrontOutlinedIcon fontSize="small" />}
            title={translate('prepackages.customer.dispatcher')}
            tag={originContact?.source === COMPANY_PROFILE_SOURCE ? translate('prepackages.customer.companyProfile') : null}
            name={originContact?.name}
            phone={formatPhone(originContact)}
          />
          <ContactSection
            icon={<PersonPinCircleOutlinedIcon fontSize="small" />}
            title={translate('prepackages.customer.receiver')}
            name={customer?.name}
            phone={formatPhone(customer)}
            email={customer?.email}
            showEmail
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          {translate('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalPrepackageCustomer;
